module.exports = __webpack_public_path__ + "img/7.7d38fd82.jpg";